import {observable, action, makeObservable} from 'mobx';
import {FormHelp, FormHelpPageState, Pages} from '../../_shared/Help/types';

export class HelpBook {
    @observable formHelp: FormHelp | null = null;
    @observable isLoadingHelpData: boolean;
    @observable helpPageQueue: FormHelpPageState[] = [];
    @observable showHelp: boolean;

    constructor() {
        makeObservable(this);
        this.initHelpPageQueue();
    }

    setHelpMessage = (helpRs: FormHelp) => {
        this.formHelp = helpRs;
    };

    @action
    setIsLoadingHelpData = (isLoading: boolean) => {
        this.isLoadingHelpData = isLoading;
    };

    @action
    setShowHelp = (isShowHelp: boolean) => {
        this.showHelp = isShowHelp;
    };

    @action
    setHelpPageQuery = query => {
        this.helpPageQueue[this.helpPageQueue.length - 1].query = query;
    };

    @action
    setHelpActiveListPage = pageNumber => {
        this.helpPageQueue[this.helpPageQueue.length - 1].activePage = pageNumber;
    };

    @action
    addHelpPage = page => {
        this.helpPageQueue.push(page);
    };

    @action
    removeHelpPage = () => {
        this.helpPageQueue.pop();
    };

    @action
    initHelpPageQueue = () => {
        this.helpPageQueue = [{page: Pages.main}];
    };
}

export const commonHelpBook = new HelpBook();
